(function (angular) {
    var SolarPredictionsController = (function () {
        function SolarPredictionsController() {
            this.init.apply(this, arguments);
        }

        SolarPredictionsController.prototype = {
            init: function ($scope, $element, $timeout) {
                $scope.vm = this;
                this.$scope = $scope;
                this.$element = $element;
                this.$timeout = $timeout;
                this.options = this.$scope.options;
                if (this.$scope.data) {
                    this.list = this.filterData(this.$scope.data);
                    this.maxY = this.$scope.data.MaxPower;
                    this.render(this.list, this.maxY);
                }
                this.watch();
                this.bindEvents();
            },
            filterData: function (data) {
                var items = data.Values,
                    months = data.Periods;
                var values = [];
                _.each(items, function (item, i) {
                    values.push({
                        Id: _.uniqueId('id-'),
                        Month: months[i],
                        Power: item
                    });
                });
                return values;
            },
            bindEvents: function () {
                var self = this;
                this.$element.on('resize', function () {
                    self.render(self.list, self.maxY);
                });
            },
            watch: function () {
                this.$scope.$watch("data", angular.bind(this, function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        this.maxY = newValue.MaxPower;
                        this.list = this.filterData(newValue);
                        this.render(this.list, this.maxY);
                    }
                }));
            },
            render: function (data, maxY) {
                //empty data
                this.$element.empty();


                var $element = this.$element,
                    container = $($element)[0],
                    width = $element.width(),
                    height = $element.height(),
                    marginBottom = 14;

                var x = d3.scaleBand().range([0, width]).padding(0.1);
                var y = d3.scaleLinear().range([0, height - marginBottom]);
                x.domain(data.map(function (d) {
                    return d.Id;
                }));
                y.domain([0, maxY]);

                var svg = d3.select(container).append("svg")
                    .attr("width", width)
                    .attr("height", height)
                    .style("transform", "scale(1,-1)")
                    .style("overflow", "visible");                    

                _.forEach(data, function (item) {
                    var g = svg.append("g");

                    // chart bar
                    g.append("rect")
                        .attr("class", "chart-bar")
                        .attr("x", function () {
                            return x(item.Id);
                        })
                        .attr("y", marginBottom)
                        .attr("width", x.bandwidth())
                        .attr("height", function () {
                            return y(item.Power);
                        });

                    // chart text
                    g.append("text")
                        .attr("class", "letter")
                        .attr("transform", "scale(1,-1)")
                        .attr("text-anchor", "middle")
                        .attr("x", function () {
                            return x(item.Id) + x.bandwidth() / 2;
                        })
                        .attr("y", 0)
                        .text(item.Month)
                        .style('fill', '#fff');

                }, this);

            }

        };
        SolarPredictionsController.$inject = ['$scope', '$element', '$timeout'];
        return SolarPredictionsController;
    }());

    angular.module('shared').directive('nfEnergyEfficientChart', function () {
        return {
            restrict: 'E',
            controller: SolarPredictionsController,
            scope: {
                'data': '='
            }
        };
    });

}(angular));